/*
 * FilePondPluginImageValidateSize 1.1.0
 * Licensed under MIT, https://opensource.org/licenses/MIT
 * Please visit https://pqina.nl/filepond for details.
 */
// test if file is of type image
const isImage = file => /^image/.test(file.type);

const getImageSize = file =>
	new Promise((resolve, reject) => {
		const image = document.createElement('img');
		image.src = URL.createObjectURL(file);
		image.onerror = err => {
			clearInterval(intervalId);
			reject(err);
		};
		const intervalId = setInterval(() => {
			if (image.naturalWidth && image.naturalHeight) {
				clearInterval(intervalId);
				URL.revokeObjectURL(image.src);
				resolve({
					width: image.naturalWidth,
					height: image.naturalHeight
				});
			}
		}, 1);
	});

const plugin$1 = ({ addFilter, utils }) => {
	// get quick reference to Type utils
	const { Type, isFile } = utils;

	// required file size
	const measureFile = (file) =>
		new Promise((resolve, reject) => {
			const onReceiveSize = ({ width, height }) => {
				// all is well
				resolve({width,height});
			};

			getImageSize(file)
				.then(onReceiveSize)
				.catch(() => {
					reject();
				});
		});

	// called for each file that is loaded
	// right before it is set to the item state
	// should return a promise
	addFilter(
		'DID_LOAD_ITEM',
		(item, { query }) =>
			new Promise((resolve, reject) => {

				const file = item.file;

				if (
					!isFile(file) ||
					!isImage(file) ||
					!query('GET_ALLOW_IMAGE_SIZE')
				) {
					resolve(file);
					return;
				}

				measureFile(file)
					.then((dimensions) => {
						item.setMetadata({
							dimensions
						});
						resolve(item);
					})
					.catch(error => {
						reject({
							status: {
								main: 'Unable to determine dimensions',
								sub: '',
							}
						});
					});
			})
	);

	// expose plugin
	return {
		// default options
		options: {
			// Enable or disable getting the Image Size
			allowImageSize: [true, Type.BOOLEAN],
		}
	};
};

if (typeof navigator !== 'undefined' && document) {
	// plugin has loaded
	document.dispatchEvent(
		new CustomEvent('FilePond:pluginloaded', { detail: plugin$1 })
	);
}

export default plugin$1;